export default defineNuxtPlugin(() => {
  // Only run on client side
  if (process.client) {
    // Initialize Brevo tracker
    const initBrevoTracker = () => {
      try {
        // Version: 2.0
        (window as any).Brevo = (window as any).Brevo || [];
        (window as any).Brevo.push([
          "init",
          {
            client_key: "i8zpkli6xzcnse9qtlu45k2t"
          }
        ]);
      } catch (error) {
        console.error('Error initializing Brevo tracker:', error);
      }
    };

    // Wait for the page to fully load
    window.addEventListener('load', () => {
      // Give the Brevo SDK time to load
      setTimeout(() => {
        initBrevoTracker();
      }, 1000);
    });
  }
});